import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '../../shared/fi-state-proxy/fi-state-names';
import { StateAccessCheckService } from '../../shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '../../shared/types';
import { PkEditContainerComponent } from './pk-edit-container/pk-edit-container.component';
import { PkSettingsComponent } from './pk-settings/pk-settings.component';
import { PkService } from './pk.service';
import { PkUnitsMatchingComponent } from './pk-units-matching/pk-units-matching.component';
import { AccessRightService } from '../../shared/fi-shared-services';
import { PkRolesMatchingComponent } from './pk-roles-matching/pk-roles-matching.component';
import { ILightWeightObject } from '../../shared/models';
import { PkUsersMatchingComponent } from './pk-users-matching/pk-users-matching.component';
import { PkUserImportComponent } from './pk-user-import/pk-user-import.component';
import { PkImportLogComponent } from './pk-import-log/pk-import-log.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { AreaService } from '@fi-app/area/area.service';

const PKState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK._name,
    url: '/PK',
    abstract: true,
    views: {
        '@': {
            component: PkEditContainerComponent,
        },
    },
};

const PKEditSettingsState_pkSettings = [
    PkService,
    (pkService: PkService) => {
        return pkService.getPKSettings();
    },
];

const PKEditSettingsState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK.Settings,
    url: '/Settings',
    component: PkSettingsComponent,
    resolve: {
        pkSettings: PKEditSettingsState_pkSettings,
        isAutoImportAvailable: [
            PkService,
            (pkService: PkService) => {
                return pkService.isAutoImportAvailable();
            },
        ],
        areas: [
            AreaService,
            (areService: AreaService) => {
                return areService.getLightWeightHieracialAreasPlain();
            },
        ],
    },
};

const PKUnitsMatchingState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK.UnitsMatching,
    url: '/UnitsMatching',
    component: PkUnitsMatchingComponent,
    resolve: {
        pkSettings: PKEditSettingsState_pkSettings,
        businessUnits: [PkService, (pkService: PkService) => pkService.getAvailableBusinessUnits()],
        existingUnitMatches: [PkService, (pkService: PkService) => pkService.getExistingUnitMatches()],
    },
};

const PKRolesMatchingState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK.RolesMatching,
    url: '/RolesMatching',
    component: PkRolesMatchingComponent,
    resolve: {
        roles: [AccessRightService, pkResolveRoles],
        existingRoleMatches: [PkService, pkResolveExistingRoleMatches],
    },
};
export function pkResolveRoles(accessRightService: AccessRightService) {
    return new Promise<ILightWeightObject[]>((resolve, reject) => {
        accessRightService.GetAccessRightsForUser().then((result) => {
            resolve(result.AccessRightCoreFilter.Roles);
        }, reject);
    });
}
export function pkResolveExistingRoleMatches(pkService: PkService) {
    return pkService.getExistingRoleMatches();
}

const PKUsersMatchingState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK.UsersMatching,
    url: '/UsersMatching',
    component: PkUsersMatchingComponent,
    resolve: {
        users: [PkService, pkResolveUsers],
        pkSettings: PKEditSettingsState_pkSettings,
    },
};
export function pkResolveUsers(pkService: PkService) {
    return pkService.getAvailableUsersForMatch();
}

const PKUserImportState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK.UserImport,
    url: '/UserImport',
    component: PkUserImportComponent,
    resolve: {
        pkSettings: PKEditSettingsState_pkSettings,
    },
};

const PKImportLogState: Ng2StateDeclaration = {
    name: FiStateNames.OtherSettings.PK.ImportLog,
    params: {
        selectedImportLogId: undefined,
    },
    url: '/ImportLog?:filterType&:sortColumn&:sortDirection&:offset',
    component: PkImportLogComponent,
    resolve: {
        selectedImportLogId: [
            FiStateService,
            Transition,
            (fiStateService: FiStateService, tr: Transition) => {
                return fiStateService.getParams(tr).selectedImportLogId;
            },
        ],
        pkSettings: PKEditSettingsState_pkSettings,
    },
};

export const PkStates: StatesModule = {
    states: [
        PKState,
        PKEditSettingsState,
        PKUnitsMatchingState,
        PKRolesMatchingState,
        PKUsersMatchingState,
        PKUserImportState,
        PKImportLogState,
    ],
};

export function registerPkStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.OtherSettings.PK._name], {
        SettingType: [ApplicationSettingsType.Personalkollen],
        AccessType: AccessRightType.Admin,
    });
}
